<span class="page-header">{{ 'DSS-Attachments' | translate }}</span>
<div class="heading">
  <div class="heading-item">
    <mat-form-field appearance="outline" class="image-selector">
      <mat-label>{{ 'Attachment' | translate }}</mat-label>
      <mat-select [value]="selectedFile" (valueChange)="onImageChange($event)" [disabled]="files.length === 1">
        @for (file of files; track file) {
          <mat-option [value]="file">
            {{ file.FileName }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="heading-item right">
    <button mat-icon-button (click)="downloadFile()">
      <mat-icon>download</mat-icon>
    </button>
    <button mat-icon-button (click)="printFile()">
      <mat-icon>print</mat-icon>
    </button>
  </div>
</div>
@if (isPdf && totalPages) {
  <p class="page-info">{{ currentPage }} / {{ totalPages }}</p>
}

@if (isLoading) {
  <div class="skeleton-loader"></div>
}
@if (!isLoading && imageUrl && !isPdf) {
  <div class="image-container">
    <lib-ngx-image-zoom
      id="img-preview"
      [thumbImage]="imageUrl"
      [fullImage]="imageUrl"
      [enableScrollZoom]="true"
      [zoomMode]="'click'"
    ></lib-ngx-image-zoom>
  </div>
}
@if (!isLoading && srcUrl && isPdf) {
  <div class="pdf-container">
    @if (!isLoading && srcUrl && isPdf) {
      <pdf-viewer
        class="pdf-viewer-component"
        [src]="url"
        [show-all]="true"
        [render-text]="true"
        [original-size]="false"
        [fit-to-page]="true"
        [autoresize]="true"
        [show-borders]="true"
        [(page)]="currentPage"
        (after-load-complete)="afterLoadComplete($event)"
      ></pdf-viewer>
    }
  </div>
}

@if (isPrinting) {
  <iframe #printf class="print-frame" [src]="srcUrl"></iframe>
}

<div #actionsContainer mat-dialog-actions class="dialog-actions-bottom" fxLayout="row" fxLayoutAlign="end center">
  <button mat-raised-button (click)="close()">{{ 'Close' | translate }}</button>
</div>
